import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {createContainer} from '@republic/react-foundation';

export default (
    createContainer(
        'DropdownContainer',
        {
            propTypes: {
                open: PropTypes.func.isRequired,
                close: PropTypes.func.isRequired,
                toggle: PropTypes.func.isRequired,
                opened: PropTypes.bool.isRequired
            }
        },
        Wrapped => (
            class extends Component {
                static displayName = (
                    `Dropdown(${
                        Wrapped.displayName ||
                        Wrapped.name ||
                        'Component'
                    })`);

                constructor(props) {
                    super(props);
                    this.state = {opened: props.opened || false};
                }

                close = () => {
                    const {opened} = this.state;

                    if (opened) {
                        this.setState({opened: false});
                    }
                }

                open = () => {
                    const {opened} = this.state;

                    if (!opened) {
                        this.setState({opened: true});
                    }
                }

                toggle = () => {
                    this.setState({opened: !this.state.opened});
                }

                render() {
                    return (
                        <Wrapped
                            close={this.close}
                            open={this.open}
                            toggle={this.toggle}
                            opened={this.state.opened}
                            {...this.props} />);
                }
            })));
